module.exports = __webpack_public_path__ + "img/cod.def4d884.svg";